import { Shield } from 'lucide-react';

import { ImageEscrow, ImageSaasEscrow, ImageBackups, ImageCustodian, ImageAiEscrow } from 'src/components/Svg/Images';

export const solutionFeatureDefinitions = {
  backup: {
    icon: ImageBackups,
    badge: {
      text: 'Ready for recovery',
      bgColor: 'bg-accent-software-backup',
    },
    features: ['Unlimited asset deposits', '50+ integrations', 'Daily asset sync', 'AES256/512 level encryption'],
    textAccentColor: 'text-accent-software-backup',
  },
  escrow: {
    icon: ImageEscrow,
    badge: {
      text: 'Ready for recovery',
      bgColor: 'bg-accent-software-escrow',
    },
    features: [
      'Assured recovery support',
      'Immutable storage',
      'Software escrow certificate',
      'Managed software backups',
    ],
    textAccentColor: 'text-accent-software-escrow',
  },
  saas: {
    icon: ImageSaasEscrow,
    badge: {
      text: 'Ready for recovery',
      bgColor: 'bg-accent-saas-escrow',
    },
    features: [
      '50+ integrations',
      '24/7 automated asset sync',
      'Continuity escrow certificate',
      'Managed software backups',
    ],
    textAccentColor: 'text-accent-saas-escrow',
  },
  continuity: {
    icon: ImageCustodian,
    badge: {
      text: 'Ready for continuity',
      bgColor: 'bg-accent-software-custodian',
    },
    features: [
      'Service continuity coverage',
      'Credential vault access',
      'Vendor access management',
      'Managed software backups',
    ],
    textAccentColor: 'text-accent-software-custodian',
  },
  'ai-escrow': {
    icon: ImageAiEscrow,
    badge: {
      text: 'Ready for recovery',
      bgColor: 'bg-accent-ai-escrow',
    },
    features: [
      'Unlimited asset deposits',
      'AES256/512 level encryption',
      'Daily asset sync',
      'Managed software backups',
    ],
    textAccentColor: 'text-accent-ai-escrow',
  },
  other: {
    icon: (props: React.SVGProps<SVGSVGElement>) => <Shield stroke="#607A8A" {...props} />,
    badge: {
      text: 'Software resilience solution',
      bgColor: 'bg-[#0B6BA2]',
    },
    features: [],
    textAccentColor: '',
  },
};
